import * as auth from './auth';
import * as firebase from './firebase';
import * as storage from './storage';
import * as db from './database';

export {
  auth,
  firebase,
  storage,
  db,
};



// WEBPACK FOOTER //
// ./src/firebase/index.js